export default "__VITE_ASSET__DWvPJ4jB__"